import { render, staticRenderFns } from "./ProgressProyecto.vue?vue&type=template&id=2789c4a3&"
import script from "./ProgressProyecto.vue?vue&type=script&lang=js&"
export * from "./ProgressProyecto.vue?vue&type=script&lang=js&"
import style0 from "./ProgressProyecto.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports